<template>
  <section v-if="items.length" class="points">
    <h3 class="points__title">{{ title }}</h3>
    <dl class="points__list">
      <div v-for="item in items" :key="item.title" class="points__item">
        <dt>{{ item.title }}</dt>
        <dd>{{ item.text }}</dd>
      </div>
    </dl>
  </section>
</template>

<script>
/** A short list of plain statements about a deal: what you own, how a listing works. */
export default {
  name: "PointsList",
  props: {
    title: { type: String, required: true },
    // [{ title, text }]
    items: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
$text-primary: #0f172a;
$text-secondary: #475569;
$border-color: #e2e8f0;

.points {
  background: #ffffff;
  border: 1px solid $border-color;
  border-radius: 12px;
  padding: 20px;

  &__title { font-size: 15px; font-weight: 600; color: $text-primary; margin: 0 0 12px; }

  &__list {
    margin: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
  }

  &__item {
    dt { font-size: 14px; font-weight: 600; color: $text-primary; margin-bottom: 4px; }
    dd { margin: 0; font-size: 13px; color: $text-secondary; line-height: 1.5; }
  }
}
</style>
